import { render, staticRenderFns } from "./StandardsReport.vue?vue&type=template&id=119645b0&scoped=true&"
import script from "./StandardsReport.vue?vue&type=script&lang=js&"
export * from "./StandardsReport.vue?vue&type=script&lang=js&"
import style0 from "./StandardsReport.vue?vue&type=style&index=0&id=119645b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119645b0",
  null
  
)

component.options.__file = "StandardsReport.vue"
export default component.exports